import React, { useEffect, useState } from 'react';
import { useERUMAUI } from '../ERUMAUI/Context_ERUMAUI';
import "./Stylesheet_Entry.css";
import Panel_Login from './Panel_Login';
import Dictionary_Global from '../Global/Dictionary_Global';
import Background_Annex from '../../Assets/Images/NSDAPS_Annex_Facade.jpg';
import UI_Image from '../ERUMAUI/UI_Image';

export default function Page_Entry() {
    const { LoadingScreen_Active_Set } = useERUMAUI();
    useEffect(() => {
        LoadingScreen_Active_Set(true);
        setTimeout(() => {
            LoadingScreen_Active_Set(false)
        }, 1000);
    }, []);

    const [Entry_Mode, Entry_Mode_Set] = useState("Login");
    return (
        <div className='Entry'>
            <div className='Entry_Form'>
                {Entry_Mode === "Login" ?
                    <Panel_Login/>
                    :
                    ""
                }
                <div className='Entry_Form_Info'>
                    <p className='General_Paragraph Entry_Form_Info_Text'>
                        Version {Dictionary_Global.Version.Number} | {Dictionary_Global.Version.Title}
                    </p>
                </div>
            </div>
            <div className='Entry_Slideshow'>
                <UI_Image
                    src={Background_Annex}
                    Fill={true}
                />
            </div>
        </div>
    );
}